/**
 * Celestial Sermons – Wall Planner v10
 * File: assets/celestial-sermons-planner.js
 */
(function () {
  'use strict';

  const CONFIG    = window.CelestialSermons;
  const MIN_SLOTS = 2;

  let allPrints    = [];
  let slotCount    = 2;
  let slots        = [null, null];
  let activeFilter = 'all';

  const DISCOUNT_TIERS = [
    { min: 5, code: 'CELESTIAL20', pct: 20 },
    { min: 3, code: 'CELESTIAL15', pct: 15 }
  ];

  const grid        = document.getElementById('csp-grid');
  const loadingEl   = document.getElementById('csp-loading');
  const wall        = document.getElementById('csp-wall');
  const countEl     = document.getElementById('csp-count');
  const minusBtn    = document.getElementById('csp-minus');
  const plusBtn     = document.getElementById('csp-plus');
  const cart        = document.getElementById('csp-cart');
  const cartItems   = document.getElementById('csp-cart-items');
  const totalEl     = document.getElementById('csp-total');
  const discountEl  = document.getElementById('csp-discount');
  const clearBtn    = document.getElementById('csp-clear');
  const checkoutBtn = document.getElementById('csp-checkout');
  const overlay     = document.getElementById('csp-overlay');
  const overlayImg  = document.getElementById('csp-overlay-img');

  // ── Init ──────────────────────────────────────────────────────
  async function init() {
    try {
      const results = await Promise.all(
        CONFIG.products.map(async (p) => {
          try {
            const res = await fetch('/products/' + p.handle + '.json');
            if (!res.ok) return null;
            const data = await res.json();
            return { config: p, product: data.product };
          } catch(e) { return null; }
        })
      );

      const byName = {};
      results.filter(Boolean).forEach(({ config, product }) => {
        const variantImageMap = {};
        (product.images || []).forEach(img => {
          (img.variant_ids || []).forEach(vid => { variantImageMap[vid] = img.src; });
        });
        const fallback = product.images?.[0]?.src || '';

        product.variants.forEach(variant => {
          const name       = variant.option1;
          const image      = variantImageMap[variant.id] || fallback;
          const sizeLabel  = config.combined ? variant.option2 : config.sizeLabel;
          const proportion = config.proportion;

          if (!byName[name]) byName[name] = { name, image, proportion, variants: [] };
          if (!byName[name].image) byName[name].image = image;

          const alreadyAdded = byName[name].variants.find(v => v.variantId === variant.id);
          if (!alreadyAdded) {
            byName[name].variants.push({
              sizeLabel,
              variantId: variant.id,
              price: parseFloat(variant.price)
            });
          }
        });
      });

      allPrints = Object.values(byName).sort((a, b) => {
        const n = s => parseInt((s.match(/\d+/) || [0])[0]);
        return n(a.name) - n(b.name);
      });

      loadingEl.style.display = 'none';
      setupFilters();
      renderBrowser();
      renderWall();

    } catch(err) {
      console.error(err);
      loadingEl.textContent = 'Something went wrong loading the prints. Please refresh.';
    }
  }

  // ── Filters ───────────────────────────────────────────────────
  function setupFilters() {
    document.querySelectorAll('.csp-filter-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        activeFilter = btn.dataset.filter;
        document.querySelectorAll('.csp-filter-btn').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        applyFilter();
      });
    });
  }

  function applyFilter() {
    grid.querySelectorAll('.csp-print').forEach(el => {
      const match = activeFilter === 'all' || el.dataset.proportion === activeFilter;
      el.style.display = match ? '' : 'none';
    });
  }

  // ── Overlay ───────────────────────────────────────────────────
  function showOverlay(src) {
    overlayImg.src = src;
    overlay.classList.add('visible');
  }

  overlay.addEventListener('click', () => overlay.classList.remove('visible'));

  // ── Browser ───────────────────────────────────────────────────
  function renderBrowser() {
    const usedNames = new Set(slots.filter(Boolean).map(s => s.print.name));

    if (!grid.children.length) {
      allPrints.forEach(print => {
        const el = document.createElement('div');
        el.className = 'csp-print' + (usedNames.has(print.name) ? ' in-use' : '');
        el.dataset.printName  = print.name;
        el.dataset.proportion = print.proportion || '';
        el.innerHTML =
          '<div class="csp-print__img-wrap">' +
            '<img class="csp-print__thumb" src="' + resizeImg(print.image, '240x240') + '" alt="' + esc(print.name) + '" loading="lazy" />' +
            '<button class="csp-print__preview-btn" title="Preview image">' +
              '<svg width="9" height="9" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                '<path d="M1 4V1H4M8 1H11V4M11 8V11H8M4 11H1V8" stroke="rgba(255,255,255,0.5)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
              '</svg>' +
            '</button>' +
          '</div>' +
          '<p class="csp-print__name">' + esc(print.name) + '</p>';

        el.querySelector('.csp-print__preview-btn').addEventListener('click', (e) => {
          e.stopPropagation();
          showOverlay(resizeImg(print.image, '800x800'));
        });

        el.addEventListener('click', () => addPrint(print));
        grid.appendChild(el);
      });

      applyFilter();
    } else {
      grid.querySelectorAll('.csp-print').forEach(el => {
        el.classList.toggle('in-use', usedNames.has(el.dataset.printName));
      });
    }
  }

  // ── Add Print ─────────────────────────────────────────────────
  function addPrint(print) {
    let fillAt = slots.findIndex(s => s === null);

    if (fillAt === -1) {
      slotCount++;
      slots.push(null);
      syncCounter();
      fillAt = slotCount - 1;
    }

    const defaultVariant = [...print.variants].sort((a, b) => a.price - b.price)[0];
    slots[fillAt] = { print, selectedVariant: defaultVariant };

    renderBrowser();
    renderWall();
    renderCart();
  }

  // ── Wall ──────────────────────────────────────────────────────
  function renderWall() {
    const cols = slotCount <= 4 ? 2 : slotCount <= 9 ? 3 : 4;
    wall.style.gridTemplateColumns = 'repeat(' + cols + ', 1fr)';
    wall.innerHTML = '';

    slots.forEach((slot, i) => {
      const wrap   = document.createElement('div');
      wrap.className = 'csp-slot-wrap';

      const slotEl = document.createElement('div');
      slotEl.className = 'csp-slot' + (slot ? ' csp-slot--filled' : '');

      if (slot) {
        const img = document.createElement('img');
        img.className = 'csp-slot__img';
        img.src = resizeImg(slot.print.image, '600x600');
        img.alt = esc(slot.print.name);
        slotEl.appendChild(img);

        slotEl.addEventListener('click', () => {
          slots[i] = null;
          renderBrowser();
          renderWall();
          renderCart();
        });

        const sizeWrap  = document.createElement('div');
        sizeWrap.className = 'csp-slot-size';

        const label = document.createElement('label');
        label.textContent = 'Size:';

        const sel = document.createElement('select');
        sel.innerHTML = slot.print.variants
          .sort((a, b) => a.price - b.price)
          .map(v =>
            '<option value="' + v.variantId + '" data-price="' + v.price + '"' +
            (v.variantId === slot.selectedVariant.variantId ? ' selected' : '') + '>' +
            esc(v.sizeLabel) + ' — $' + v.price.toFixed(2) +
            '</option>'
          ).join('');

        sel.addEventListener('change', function() {
          const opt = this.options[this.selectedIndex];
          slots[i].selectedVariant = {
            variantId: parseInt(this.value),
            price:     parseFloat(opt.dataset.price),
            sizeLabel: opt.text.split(' —')[0].trim()
          };
          renderCart();
        });

        sizeWrap.appendChild(label);
        sizeWrap.appendChild(sel);
        wrap.appendChild(slotEl);
        wrap.appendChild(sizeWrap);

      } else {
        slotEl.innerHTML = '<span class="csp-slot__plus">+</span>';
        wrap.appendChild(slotEl);
      }

      wall.appendChild(wrap);
    });
  }

  // ── Counter ───────────────────────────────────────────────────
  function syncCounter() {
    countEl.textContent  = slotCount;
    minusBtn.disabled    = slotCount <= MIN_SLOTS;
  }

  function updateCount(n) {
    if (n < MIN_SLOTS) return;
    slotCount = n;
    if (slots.length > slotCount) slots = slots.slice(0, slotCount);
    else while (slots.length < slotCount) slots.push(null);
    syncCounter();
    renderBrowser();
    renderWall();
    renderCart();
  }

  minusBtn.addEventListener('click', () => updateCount(slotCount - 1));
  plusBtn.addEventListener('click',  () => updateCount(slotCount + 1));

  // ── Cart ──────────────────────────────────────────────────────
  function renderCart() {
    const filled     = slots.filter(Boolean);
    const countBadge = document.getElementById('csp-count-badge');

    if (!filled.length) {
      cart.classList.remove('visible');
      return;
    }

    cart.classList.add('visible');
    if (countBadge) countBadge.textContent = filled.length;

    const total = filled.reduce((sum, s) => sum + s.selectedVariant.price, 0);
    totalEl.textContent = '$' + total.toFixed(2);

    const tier = DISCOUNT_TIERS.find(t => filled.length >= t.min);
    if (tier) {
      discountEl.textContent = tier.pct + '% off — use code ' + tier.code;
    } else {
      const next = DISCOUNT_TIERS[DISCOUNT_TIERS.length - 1];
      discountEl.textContent = 'Add ' + (next.min - filled.length) + ' more to unlock ' + next.pct + '% off';
    }
    discountEl.classList.add('visible');

    cartItems.innerHTML = '';
    slots.forEach((slot, i) => {
      if (!slot) return;
      const item = document.createElement('div');
      item.className = 'csp-cart__item';
      item.innerHTML =
        '<img src="' + resizeImg(slot.print.image, '80x80') + '" alt="" />' +
        '<div class="csp-cart__item-info">' +
          '<p class="csp-cart__item-name">' + esc(slot.print.name) + '</p>' +
          '<p class="csp-cart__item-size">' + esc(slot.selectedVariant.sizeLabel) + ' · $' + slot.selectedVariant.price.toFixed(2) + '</p>' +
        '</div>' +
        '<button class="csp-cart__item-remove" title="Remove">×</button>';
      item.querySelector('.csp-cart__item-remove').addEventListener('click', () => {
        slots[i] = null;
        renderBrowser();
        renderWall();
        renderCart();
      });
      cartItems.appendChild(item);
    });
  }

  clearBtn.addEventListener('click', () => {
    slots = Array(slotCount).fill(null);
    renderBrowser();
    renderWall();
    renderCart();
  });

  checkoutBtn.addEventListener('click', async function() {
    const filled = slots.filter(Boolean);
    if (!filled.length) return;
    checkoutBtn.textContent = 'Adding…';
    checkoutBtn.disabled    = true;
    try {
      const items = filled.map(s => ({ id: s.selectedVariant.variantId, quantity: 1 }));
      const res   = await fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ items })
      });
      if (!res.ok) throw new Error('Cart error');
      window.location.href = '/cart';
    } catch(err) {
      console.error(err);
      checkoutBtn.textContent = 'Something went wrong';
      checkoutBtn.disabled    = false;
      setTimeout(() => { checkoutBtn.textContent = 'Add All to Cart →'; }, 3000);
    }
  });

  // ── Helpers ───────────────────────────────────────────────────
  function resizeImg(src, size) {
    if (!src) return '';
    return src.replace(/(\.[a-z]+)(\?.*)?$/i, '_' + size + '$1$2');
  }

  function esc(str) {
    return String(str || '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  init();
})();